import React from 'react'
import { Trans } from '@lingui/react/macro'

import style from './index.module.scss'

import type { IDefinedArticleCategoryAttributes } from '@duiyun/strapi-v4'
import type { IArticleCategoryKeys } from '@duiyun/strapi-v4/dist/types/articles'


import { cls } from 'tagged-classnames-free';
import Link from '@/components/Link';
export interface ISidebarProps {
  className?: string
  data?: Pick<IDefinedArticleCategoryAttributes, IArticleCategoryKeys>[]
  currentCategoryUrl: string
}

const Sidebar: React.FC<ISidebarProps> = (props) => {
  const { className, data, currentCategoryUrl } = props

  if (!data) {
    return null
  }

  return (
    <div
      className={cls`
        text-f-text-secondary 
        border-f-border sticky
        top-20 h-fit w-full 
        items-center rounded-lg
        border py-3
        pe-3 ps-6 md:w-[224px]
        ${style.sidebar}
        ${className} 
      `}
    >
      <ul
        className={cls`
          relative h-full
          flex-1 space-y-2 text-sm
          font-semibold before:absolute
          before:inset-y-1 before:-left-3
          before:w-[2px] before:rounded-full 
          before:bg-[#34343a]
          md:space-y-3
          lg:text-base 
          [&>li]:hover:cursor-pointer
        `}
      >
        <li
          className={cls`
            ${currentCategoryUrl === '/hub' && 'active'} 
          `}
        >
          <Link href={'/hub'}>
            <Trans>All Articles</Trans>
          </Link>
        </li>
        {data.map((item, index) => {
          return (
            <li
              key={item.url}
              className={cls`${currentCategoryUrl === item.url && 'active'}`}
            >
              <Link href={item.url}>{item.h1}</Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
export default Sidebar
